import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import CreateIncOdooPoView from "./CreateIncOdooPoView";
import CreateIncOdooSoView from "./CreateIncOdooSoView";
import { FETCH_PLAN_FOR_INC_ODOO } from "./graphql";
import SyncPlanToPoView from "./SyncPlanToPoView";
import SyncPlanToSoView from "./SyncPlanToSoView";

const IncOdooOrdersView = ({ planId }) => {
  const { odooUrlInc } = useContext(OdooContext);
  const { loading, error, data } = useQuery(FETCH_PLAN_FOR_INC_ODOO, {
    variables: { planId },
  });
  const modal = useModals();

  if (loading)
    return (
      <div className="card relative">
        <InlineSpinner size={18} />
      </div>
    );

  if (error)
    return (
      <div className="card relative">
        <Errors error={error} />
      </div>
    );

  const originalPlan = data.productionPlan;
  const extraData = JSON.parse(originalPlan.extraData || "{}");

  function createOdooSO() {
    modal.present({
      title: "Create Odoo SO",
      maxWidth: "max-w-6xl",
      children: (
        <CreateIncOdooSoView
          planId={planId}
          extraData={extraData}
          hide={modal.hide}
        />
      ),
    });
  }

  function syncPlanToSo() {
    modal.present({
      title: "Sync Plan to INC Odoo SO",
      maxWidth: "max-w-6xl",
      children: (
        <SyncPlanToSoView
          planId={planId}
          soId={originalPlan.odooIncSo.objectId}
          hide={modal.hide}
        />
      ),
    });
  }

  function syncPlanToPo() {
    modal.present({
      title: "Sync Plan to INC Odoo PO",
      maxWidth: "max-w-6xl",
      children: (
        <SyncPlanToPoView
          planId={planId}
          poId={originalPlan.odooIncPo.objectId}
          hide={modal.hide}
        />
      ),
    });
  }

  function createOdooPO() {
    modal.present({
      title: "Create Odoo PO",
      maxWidth: "max-w-6xl",
      subtitle: "Create PO in INC Odoo for this plan",
      children: <CreateIncOdooPoView planId={planId} hide={modal.hide} />,
    });
  }

  return (
    <div className="space-y-2">
      {originalPlan.planType === "INC_FOB_ORDER" && (
        <>
          {originalPlan.odooIncSo ? (
            <div className="space-x-3 flex">
              <div>
                <a
                  className="text-purple-600"
                  href={`${odooUrlInc}/odoo/sales/${originalPlan.odooIncSo.objectId}`}
                  target="_blank"
                >
                  {originalPlan.odooIncSo.objectName}
                </a>
              </div>
              <Button onClick={syncPlanToSo}>Sync SO</Button>
            </div>
          ) : (
            <div className="space-y-1">
              {!extraData.fobCustomer && (
                <div className=" opacity-70 text-red-600 font-semibold">
                  Choose FOB Customer and save before creating SO for Odoo.
                </div>
              )}
              <Button onClick={createOdooSO} disabled={!extraData.fobCustomer}>
                Create SO for FOB Customer
              </Button>
            </div>
          )}
        </>
      )}

      {(originalPlan.planType === "INC_FOB_ORDER" ||
        originalPlan.planType === "INC_STOCK_ORDER" ||
        originalPlan.planType === "INC_AMAZON_SELLER_CENTRAL_ORDER") && (
        <>
          {originalPlan.odooIncPo ? (
            <div className="space-x-3 flex">
              <div>
                <a
                  className="text-purple-600"
                  href={`${odooUrlInc}/odoo/purchase/${originalPlan.odooIncPo.objectId}`}
                  target="_blank"
                >
                  {originalPlan.odooIncPo.objectName}
                </a>
              </div>
              <div>
                <Button onClick={syncPlanToPo}>Sync PO</Button>
              </div>
            </div>
          ) : (
            <Button onClick={createOdooPO}>Create PO for Waboba AB</Button>
          )}
        </>
      )}
    </div>
  );
};

export default IncOdooOrdersView;
